import React from 'react'
import { removeSelectedItems } from '@disco/state-management/actions/ShortlistActions'
import { PHONE } from '@disco/constants/DeviceTypes'
import { useMenu } from 'components/ds'
import { useDispatch, useSelector } from 'hooks/use-redux'

type Props = {
  shortlistId: string
  itemIndex: number
}

const RemoveFromShortlist = ({
  shortlistId,
  itemIndex,
}: Props): React.ReactNode => {
  const Menu = useMenu()
  const dispatch = useDispatch()
  const mobileDeviceType = useSelector(state => state.app.mobileDeviceType)

  if (mobileDeviceType !== PHONE) return null

  return (
    <Menu.Item
      onSelect={() => dispatch(removeSelectedItems(shortlistId, [itemIndex]))}
    >
      Remove from shortlist
    </Menu.Item>
  )
}

export default RemoveFromShortlist
